import { createContext } from "react";

interface initialStateType {
  state: AuthStateType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setState: any;
  login: any,
  logout: any,
}

const initialAuthContextValue = {
  state: {
    _id: '',
    name: '',
    email: '',
    role: '',
    token: '',
  },
  setState: () => { },
  login: () => { },
  logout: () => { }
}

const AuthContext = createContext<initialStateType>(initialAuthContextValue);

export default AuthContext;
